import { FormInput } from "@4uhub/lib4uhub";
import { Grid, FormHelperText } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useAutomationRules } from "../../../../../../../store/contexts/AutomationRulesContext";

const translationPath = "chatBot.page.automations.automationRuleEncMessage.";

export const IndividualIdentifierField = memo(() => {
  const { t } = useTranslation();

  const { automation } = useAutomationRules();

  if (
    !automation ||
    !automation.code ||
    !["28", "29"].includes(automation.code)
  )
    return null;

  return (
    <Grid item xs={12} sm={12}>
      <FormInput
        size="small"
        name="individualIdentifier"
        fullWidth
        label={
          t(translationPath + "individualIdentifier") || "individualIdentifier"
        }
      />
      <FormHelperText>
        {t(translationPath + "individualIdentifierMessageHelper")}
      </FormHelperText>
    </Grid>
  );
});
